import { useQuery } from '@tanstack/react-query';
import { supabase } from '../lib/supabase';
import { Organizer } from '../types';

export const useOrganizers = () => {
    return useQuery({
        queryKey: ['organizers'],
        queryFn: async () => {
            const { data: allOrgs } = await supabase.from('organizers').select('*');
            const orgs = (allOrgs || []) as Organizer[];
            
            if (!orgs.length) return [];

            const ownerIds = orgs.map(o => o.owner_id).filter(Boolean) as string[];
            if (!ownerIds.length) return [];

            const { data: profiles, error: pErr } = await supabase
                .from('profiles')
                .select('id, role')
                .in('id', ownerIds);

            if (pErr || !profiles) return [];
            
            const allowed = new Set(((profiles || []) as { id: string; role: string }[]).filter(p => p.role === 'organizer').map(p => p.id));
            return orgs.filter(o => o.owner_id && allowed.has(o.owner_id));
        },
        staleTime: 1000 * 60 * 10, // 10 minutes
    });
};
